export const SYNC_SOURCE = {
    google: 'google',
    microsoft: 'microsoft',
    oidc: 'oidc',
} as const;

export const WEB_DESKTOP_DOMAIN_KEY = 'integrationaccessdomain-8';

/**
 * Integration access expiration for remember me is set to 30 days.
 * So User have to log in back every month
 */
export const WEB_DESKTOP_TOKEN_EXPIRATION_IN_MINUTES = 60 * 24 * 30; // 30 Days
